import React, { useEffect, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import SimpleBar from "simplebar-react"
import { useRef } from "react"

//i18n
import { withTranslation } from "react-i18next"
import CommonApi from "Api/CommonApi"

const NotificationDropdown = props => {
  const accessToken = localStorage.getItem("accessToken")
  const [menu, setMenu] = useState(false)
  const containerRef = useRef(null)

  const universityRender = data => {
    return (
      <Link to="/universitylist" className="text-reset notification-item">
        <div className="d-flex">
          <div className="flex-shrink-0 me-3">
            <div className="avatar-xs me-3">
              <span className="avatar-title border-success rounded-circle ">
                <i className="ion ion-ios-school"></i>
              </span>
            </div>
          </div>
          <div className="flex-grow-1">
            <h6 className="mt-0 mb-1">University Data Added!</h6>
            <div className="text-muted">
              <p className="mb-1">{data.content}</p>
            </div>
          </div>
        </div>
      </Link>
    )
  }

  const [notifications, setNotifications] = useState([])

  const fetchAllNotifications = useCallback(() => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    CommonApi.getNotificationByUserId(config)
      .then(res => {
        console.log(res.data)
        setNotifications(res.data.data)
      })
      .catch(err => {
        console.log(err)
      })
  }, [accessToken])

  useEffect(() => {
    fetchAllNotifications()
  }, [fetchAllNotifications])

  useEffect(() => {
    const handleDocumentClick = event => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setMenu(false)
      }
    }

    document.addEventListener("mousedown", handleDocumentClick)

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick)
    }
  }, [])

  const renderNotification = data => {
    if (data.type === "university") {
      return universityRender(data)
    }
  }

  return (
    <div className="dropdown d-inline-block ms-1 position-relative" ref={containerRef}>
      <button
        type="button"
        className="btn header-item noti-icon waves-effect"
        id="page-header-notifications-dropdown"
        onClick={() => setMenu(current => !current)}
      >
        <i className="ti-bell"></i>
        {notifications?.length > 0 && (
          <span className="badge text-bg-danger rounded-pill">
            {notifications?.length}
          </span>
        )}
      </button>

      {menu ? (
        <div
          className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
          style={{ display: "block" }}
        >
          <div className="p-3">
            <div className="row align-items-center">
              <div className="col">
                <h5 className="m-0">
                  {props.t("Notifications")} ({notifications?.length})
                </h5>
              </div>
              <div className="col text-end">
                <button
                  type="button"
                  className="btn btn-link p-0"
                >
                  Clear All
                </button>
              </div>
            </div>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {notifications.map(notification =>
              renderNotification(notification),
            )}
            {/* <Link to="#" className="text-reset notification-item">
              <div className="d-flex">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title border-success rounded-circle ">
                      <i className="mdi mdi-cart-outline"></i>
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mt-0 mb-1">Your order is placed</h6>
                  <div className="text-muted">
                    <p className="mb-1">
                      If several languages coalesce the grammar
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="#" className="text-reset notification-item">
              <div className="d-flex">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title border-warning rounded-circle ">
                      <i className="mdi mdi-message"></i>
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mt-0 mb-1">New Message received</h6>
                  <div className="text-muted">
                    <p className="mb-1">You have 87 unread messages</p>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="#" className="text-reset notification-item">
              <div className="d-flex">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title border-info rounded-circle ">
                      <i className="mdi mdi-glass-cocktail"></i>
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mt-0 mb-1">Your item is shipped</h6>
                  <div className="text-muted">
                    <p className="mb-1">
                      It is a long established fact that a reader will
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="#" className="text-reset notification-item">
              <div className="d-flex">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title border-primary rounded-circle ">
                      <i className="mdi mdi-cart-outline"></i>
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mt-0 mb-1">Your order is placed</h6>
                  <div className="text-muted">
                    <p className="mb-1">
                      Dummy text of the printing and typesetting industry.
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="#" className="text-reset notification-item">
              <div className="d-flex">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title border-warning rounded-circle ">
                      <i className="mdi mdi-message"></i>
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-1">New Message received</h6>
                  <div className="text-muted">
                    <p className="mb-1">You have 87 unread messages</p>
                  </div>
                </div>
              </div>
            </Link> */}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <button
              type="button"
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {props.t("View all")}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}
